import { FormikNumber } from "../../../../../components/FormikFields/FormikNumber.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/count/CountOccurrenceForm.tsx
function CountOccurrenceForm({ name }) {
	return /* @__PURE__ */ jsx("div", {
		className: "min-w-0 flex-1",
		children: /* @__PURE__ */ jsx(FormikNumber, {
			hint: "required",
			label: "Minimum count",
			min: 1,
			name: `${name}.minCount`,
			step: 1,
			subText: "Must be at least 1"
		})
	});
}
//#endregion
export { CountOccurrenceForm };

//# sourceMappingURL=CountOccurrenceForm.js.map